import { Box, Button, Typography } from "@mui/material";
import { parseAssistantMessage, SegmentType } from "./utils";
import { styles } from "./ChatSlideout";
import { FormattedText } from "./FormattedText";

type AssistantSegmentsProps = {
  content: string;
  onApply: (caption: string) => void;
  onClose: () => void;
};

const FIRST_SEGMENT_INDEX = 0;
const TEXT_SEGMENT_TOP_MARGIN = 1.5;

export function AssistantSegments({ content, onApply, onClose }: AssistantSegmentsProps) {
  return <>
    {parseAssistantMessage(content).map((segment, sIdx) => {
      if (segment.type === SegmentType.Text) {
        return (
          <Box key={sIdx} sx={{ ...styles.messageText, mt: sIdx > FIRST_SEGMENT_INDEX ? TEXT_SEGMENT_TOP_MARGIN : 0 }}>
            <FormattedText>{segment.content}</FormattedText>
          </Box>
        );
      }

      return (
        <Box key={sIdx} sx={styles.optionCard}>
          <Typography variant="caption" sx={styles.optionLabel}>
            Option {segment.index}
          </Typography>
          <Box sx={styles.optionText}><FormattedText>{segment.content}</FormattedText></Box>
          <Button
            size="small"
            variant="contained"
            sx={styles.applyButton}
            onClick={() => { onApply(segment.content); onClose(); }}
          >
            Apply
          </Button>
        </Box>
      );
    })}
  </>;
}
